import { request } from 'graphql-request';
async function fetcher(query, vars = {}) {
  if (!vars.contentAreaSlug) {
    vars.contentAreaSlug =
      process.env.CONTENT_AREA_SLUG ||
      process.env.NEXT_PUBLIC_CONTENT_AREA ||
      'mprnews';
  }
  const endpoint = process.browser
    ? process.env.GRAPHQL_API
    : process.env.PRIVATE_GRAPHQL_API;
  const realEndpoint = endpoint
    ? endpoint
    : 'https://cmsapi.publicradio.org/graphql';
  try {
    return request(realEndpoint, query, vars);
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // re-throw the error to propagate it up the call stack
  }
}
export default fetcher;
